import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import Modal from 'ui-components/components/modal';
import ModalHeader from 'ui-components/components/modal/modal-header';
import ModalBody from 'ui-components/components/modal/modal-body';
import ModalFooter from 'ui-components/components/modal/modal-footer';
import { useLocale } from '../../../intl/hooks';
import asModal from '../../as-modal';
import LanguageSelectionDropdown from '../../../intl/components/language-selection-dropdown';
import formatters from '../../../intl/formatters';
import style from './language-selection-modal.less';

const LanguageSelectionModal = ({ onClose }) => {
  const { locale: localeFromContext, setLocale, availableLocales } = useLocale();
  const [currentLocale, setCurrentLocale] = useState(localeFromContext);
  const onLocaleChange = useCallback(
    (language) => {
      setCurrentLocale(language);
    },
    [setCurrentLocale],
  );

  const onSave = useCallback(() => {
    setLocale(currentLocale);
    onClose();
  }, [currentLocale, setLocale, onClose]);

  return (
    <Modal className={style['language-selection-modal']}>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage defaultMessage='Preferred Language' description='language selection modal title' id='dMN9Rk' />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div>
          <FormattedMessage
            defaultMessage="This will be the language you will see when you're logged in the <AppBrandName></AppBrandName>. This will not change the language used in labels, pick lists, and other customer facing items."
            description='preferred language selection info'
            id='UMe0XW'
            values={{ AppBrandName: formatters.AppBrandName }}
          />
        </div>
        <div className={style['language-selection-dropdown']}>
          <label>
            <FormattedMessage defaultMessage='Language' description='language dropdown label' id='vq/kvG' />
          </label>
          <LanguageSelectionDropdown availableLocales={availableLocales} currentLocale={currentLocale} onLocaleChange={onLocaleChange} />
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button onClick={onClose} theme='tertiary'>
          <FormattedMessage defaultMessage='Cancel' description='Preferred Language modal cancel' id='mKGjnl' />
        </Button>
        <Button disabled={currentLocale === localeFromContext} onClick={onSave} theme='primary'>
          <FormattedMessage defaultMessage='Save' description='save preferred language' id='Q0GfhD' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

LanguageSelectionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default asModal(LanguageSelectionModal);
